import React from 'react';
import ErrorTemplate from '../ErrorTemplate';

class Error400 extends React.Component {
  render() {
    return (
      <div>     
     
         <ErrorTemplate
        errorCode="400"
        errorMessage="'Bad Request"
      />
      </div>

    );
  }
}

export default Error400;